import React from "react";

export default function NotFoundPage(): JSX.Element {
  return <div className="not-found-page mt-4xl">Selected page can't be found.</div>;
}
